import { defineMessages } from 'react-intl';

export default defineMessages({
    repairFacilityMapHeader: {
        id: 'fnol.pa.views.pa-preferred-body-shop.What recommended repair facility suits you best?',
        defaultMessage: 'What recommended repair facility suits you best?',
    },
});
